import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './PeupleQcWall.css';
import { PeupleQcCombinedHeader } from "./PeupleQcCombinedHeader.js";
import { SocialPost } from "./SocialPost.js";
import { NotificationsList } from "./NotificationsList.js";
import { SocialCreatePost } from "./SocialCreatePost";
import { SocialTopShortcut } from "./SocialTopShortcut";
import { SocialUserApp } from "./SocialUserApp";
import { Tiktok } from "./Tiktok";
import { Spinner, Container, Row, Col } from "reactstrap";
import VisibilitySensor from "react-visibility-sensor";
import { MaleOrFemale } from "./MaleOrFemale";
import { PageSuggestions } from "./PageSuggestions";
import { GroupSuggestion } from "./GroupSuggestion";
import { AdSocialPage } from "./AdSocialPage";
import { AdDisplay } from "./AdDisplay";
import { PeupleWallLeftSide } from "./PeupleWallLeftSide";
import { ShowHasScreen } from "./ShowHasScreen";
import { AdSpace } from "./AdSpace";
import { NoPostYet } from "./NoPostYet";
import { GamersSummary } from "./GamersSummary";
import { SocialNewUserHint } from "./SocialNewUserHint";
import { UsersSuggestion} from "./UsersSuggestion";

const PeupleQcWall = ({ user }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [posts, setPosts] = useState([]);
  const [activeTab, setActiveTab] = useState("home");
  const [lastId, setLastId] = useState(null);
  const [nbrAds, setNbrAds] = useState(0);
  const [numPage, setNumPage] = useState(0);

  const setNewPost = (post) => setPosts((oldPosts) => [post, ...oldPosts]);

  const setNewPosts = (posts) => setPosts((oldPosts) => [...oldPosts, ...posts]);

  const fetchViral = async () => {
    const post = await sdk.models.post.getViralPosts({ num_page: numPage });
    setPosts((oldPosts) => [...oldPosts, post]);
  };

  const fetchAd = async () => {
    const ad = await sdk.models.AdServer.selectDisplayAd({
        zoneId: "peupleqc_wall",
        size: "600x500"
    });
    if (ad === null) return;
    setNbrAds(nbrAds + 1);
    setNewPosts([ad]);
  };

  const fetchDatas = async () => {
    setIsLoading(true);
    const p = await sdk.models.post.getUserWall({ last_id: lastId });
    if (typeof p.error !== "undefined") return setIsLoading(false);
    if (p.length === 0) return setIsLoading(false);
    setNewPosts(p);
    setLastId(p[p.length - 1].id);
    setIsLoading(false);
  };

  const onChangeLikes = async () => {
    setIsLoading(true);
    const p = await sdk.models.post.getUserWall({});
    if (typeof p.error !== "undefined") return setIsLoading(false);
    if (p.length === 0) return setIsLoading(false);
    setPosts(p);
    setLastId(p[p.length - 1].id);
    setIsLoading(false);
  };

  let isFetching = false; // Flag pour éviter les appels multiples

  const fetchThings = async () => {
      if (isFetching) return; // Empêche une exécution simultanée
      isFetching = true;
      setNumPage((prev) => prev + 1);

      try {
          await fetchViral();
          await fetchAd();
          await fetchDatas();
      } catch (error) {
          console.error("Erreur lors de l'exécution de fetchThings:", error);
      } finally {
          isFetching = false; // Libère le verrou après l'exécution
      }
  };

  useEffect(() => {
    localStorage.removeItem("chatTaskId");
    fetchThings();
  }, []);

  const viewed = async (isVisible) => {
    if (isVisible && !isFetching) {
      fetchThings();
    }
  };

  return (    
    <PeupleQcCombinedHeader 
      activeTab={activeTab} 
      setActiveTab={setActiveTab} 
      user={user}
    >
      <Container fluid className="px-0">
        <Row className="mx-0">
          {/* Colonne de gauche - visible à partir des tablettes */}
          <Col xs={12} md={3} lg={3} xl={3} className="d-none d-md-block">
            <PeupleWallLeftSide user={user} />
          </Col>

          {/* Colonne principale - toujours visible */}
          <Col xs={12} md={9} lg={6} xl={6} className="px-0">
            {activeTab === "home" && (
              <>
                <ShowHasScreen />
                <SocialCreatePost user={user} setNewPost={setNewPost} />
                <SocialTopShortcut />
                <MaleOrFemale user={user} />
                <UsersSuggestion />
                <PageSuggestions onChange={onChangeLikes} />
                <GroupSuggestion onChange={onChangeLikes} />
                <GamersSummary />
                {posts.map((post, index) => {
                  if (!post) return null;
                  if (post.type) {
                    if (post.type === "boosted") {
                      return <AdSocialPage key={index} page={post.boostedPage} />;
                    }
                    if (post.type === "ad" || post.type === "market_item") {
                      return <AdDisplay key={index} ad={post} />;
                    }
                  }
                  return <SocialPost key={index} post={post} />;
                })}
                {posts.length === 0 && <NoPostYet />}
                <div className="text-center mt-3 mb-3">
                  <VisibilitySensor
                    partialVisibility
                    onChange={(isVisible) => viewed(isVisible)}
                  >
                    <Spinner color="primary" />
                  </VisibilitySensor>
                </div>
              </>
            )}
            {activeTab === "notifications" && <NotificationsList />}
            {activeTab === "videos" && <Tiktok />}
            {activeTab === "profile" && <SocialUserApp />}
          </Col>

          {/* Colonne de droite - visible uniquement sur grands écrans */}
          <Col lg={3} xl={3} className="d-none d-lg-block">
            <div className="position-sticky" style={{ top: '70px' }}>
              <AdSpace zoneId={"peupleqc-right-side"} height={"600px"}/>
            </div>
          </Col>
        </Row>
      </Container>
    </PeupleQcCombinedHeader>
  );
};

export { PeupleQcWall };